import type { HexData } from "@west-marches/shared";
import { hexToPixel } from "@west-marches/shared";

export const DEFAULT_MAP_CAMERA = { x: 0, y: 0, zoom: 0.7 } as const;

export function getVisibleHexKeys(
  hexes: Record<string, HexData>,
  sortedKeys: string[],
  camera: { x: number; y: number; zoom: number },
  width: number,
  height: number,
): string[] {
  const paddingX = 160;
  const paddingY = 160;
  const minX = (-width / 2 - camera.x) / camera.zoom - paddingX;
  const maxX = (width / 2 - camera.x) / camera.zoom + paddingX;
  const minY = (-height / 2 - camera.y) / camera.zoom - paddingY;
  const maxY = (height / 2 - camera.y) / camera.zoom + paddingY;
  const visibleKeys: string[] = [];

  for (const key of sortedKeys) {
    const hex = hexes[key];
    const point = hexToPixel({ q: hex.q, r: hex.r });
    if (point.x < minX || point.x > maxX || point.y < minY || point.y > maxY) {
      continue;
    }

    visibleKeys.push(key);
  }

  return visibleKeys;
}

export function getMapHexKeysSortedByY(
  hexes: Record<string, HexData>,
): string[] {
  return Object.keys(hexes).sort((a, b) => {
    const ha = hexes[a];
    const hb = hexes[b];
    const pa = hexToPixel({ q: ha.q, r: ha.r });
    const pb = hexToPixel({ q: hb.q, r: hb.r });
    return pa.y - pb.y;
  });
}
